import type { MouseEvent } from 'react';
import type { ProjectStatusId } from '@witmetrics/utils';
import { PROJECT_STATUSES } from '@witmetrics/utils/constants';
import Menu, { MenuItem, type MenuProps } from '@/components/Menu';
import ProjectStatusCircle from '@/components/ProjectStatusCircle';
import { classes } from './utils';

export interface ProjectStatusMenuProps extends MenuProps {
  onChange: (projectStatusId: ProjectStatusId) => void;
}

export default function ProjectStatusMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  onChange,
  onClose,
}: ProjectStatusMenuProps) {
  const handleChange = (e: MouseEvent, projectStatusId: ProjectStatusId) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(projectStatusId);
    onClose();
  };

  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={classes.menu}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <ul>
        {Object.values(PROJECT_STATUSES).map((status) => (
          <MenuItem
            key={status.id}
            label={status.label}
            icon={
              <ProjectStatusCircle
                className={classes.icon}
                projectStatusId={status.id}
                size={18}
              />
            }
            onClick={(e) => handleChange(e, status.id)}
          />
        ))}
      </ul>
    </Menu>
  );
}
